import { render } from "./SplashView.vue?vue&type=template&id=4ad1317a"
import script from "./SplashView.vue?vue&type=script&lang=js"
export * from "./SplashView.vue?vue&type=script&lang=js"

import "./SplashView.vue?vue&type=style&index=0&id=4ad1317a&lang=css"

import exportComponent from "C:\\Users\\stage\\NetttFormApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__